import { useAuth } from "@/context/auth";
import { Button } from "@/components/ui/button";
import { useLocation } from "wouter";
import { Wrench } from "lucide-react";

export default function Maintenance() {
  const { user } = useAuth();
  const [, setLocation] = useLocation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800 px-4 text-center">
      {/* Animated icon */}
      <div className="mb-8 relative">
        <div className="w-24 h-24 rounded-full bg-primary/10 flex items-center justify-center mx-auto animate-pulse">
          <Wrench className="w-12 h-12 text-primary" />
        </div>
      </div>

      <h1 className="text-3xl font-bold tracking-tight text-slate-900 dark:text-slate-50 mb-3">
        We're Working on This Page
      </h1>
      <p className="text-slate-500 dark:text-slate-400 max-w-md text-base leading-relaxed mb-8">
        We are currently making improvements to give you a better experience.
        Please check back shortly — we'll be back up very soon!
      </p>

      <div className="flex items-center gap-1.5 text-sm text-slate-400 dark:text-slate-500 mb-10">
        <span className="inline-block w-2 h-2 rounded-full bg-amber-400 animate-bounce" style={{ animationDelay: "0ms" }} />
        <span className="inline-block w-2 h-2 rounded-full bg-amber-400 animate-bounce" style={{ animationDelay: "150ms" }} />
        <span className="inline-block w-2 h-2 rounded-full bg-amber-400 animate-bounce" style={{ animationDelay: "300ms" }} />
        <span className="ml-2">Hang tight while we upgrade things</span>
      </div>

      {/* Only admins see the manage subscription link */}
      {user?.role === "admin" || user?.role === "superadmin" ? (
        <Button onClick={() => setLocation("/subscribe")} variant="outline" size="sm">
          Manage Subscription
        </Button>
      ) : null}
    </div>
  );
}
